// Function to add or update label for an input
export function createOrUpdateLabels(input, key) {
    let containerElement = input.parentNode;
    if (!containerElement.classList.contains('festi-input-container')) {
        containerElement = document.createElement('div');
        containerElement.className = 'festi-input-container';
        input.parentNode.insertBefore(containerElement, input);
        containerElement.appendChild(input);
    }

    let labelElement = containerElement.querySelector('label');
    if (!labelElement) {
        labelElement = document.createElement('label');
        containerElement.insertBefore(labelElement, input);
    }
    labelElement.textContent = key.charAt(0).toUpperCase() + key.slice(1);
}
